require('./command.js');

(function(){
  PegasusTemplate.MoveColumnCommand = PegasusTemplate.Command.extend({
    klass: null,
    backup: null,
    sourceElement: null,
    callback: null,
    parent: null,
    childPosition: null,
    descriptionClass: 'moved',
    description: function(){
      return Em.I18n.t('command_descriptions.moved_column');
    }.property(),
    execute: function() {
      var parent = PegasusTemplate.blockRegionInstance,
        row = parent.objectAt( this.get('rowPosition') ),
        sourceCode = this.get('backup'),
        sourceId = this.get('currentPosition'),
        targetId = this.get('desiredPosition'),
        _super = this._super.bind(this);

      var element = $(sourceCode);

      var columnA = element.find('#' + sourceId);
      var columnB = element.find('#'+ targetId);

      var parentA = columnA.parent();
      var parentB = columnB.parent();

      if ( parentA.attr('id') === parentB.attr('id') ) {
        var aparent = parentA[0];
        var a = columnA[0];
        var b = columnB[0];
        var asibling = a.nextSibling === b ? a : a.nextSibling;
        b.parentNode.insertBefore(a, b);
        aparent.insertBefore(b, asibling);
      } else {
        columnA.remove();
        columnB.remove();

        parentA.append( columnB );
        parentB.append( columnA );
      }

      var source = element[0].outerHTML;

      parent.removeObject( row );
      parent.insertAt( this.get('rowPosition'), this.get('rowKlass').create({
        container: parent.container,
        sourceElement: source
      }) );

      _super();
    },

    unexecute: function(callback){
      var parent = PegasusTemplate.blockRegionInstance,
        reborn = this.get('rowKlass').create({
          container: parent.container,
          sourceElement: this.get('backup')
        }),
        _super = this._super.bind(this);

      parent.removeObject( parent.objectAt( this.get('rowPosition') ) );
      parent.insertAt( this.get('rowPosition'), reborn );

      Em.run.scheduleOnce( 'afterRender', reborn, function(){
        this.set('isVisible', true);
        this.$().addClass('bounce-in-right').addClass('animated').addClass('make_transit');
        _super();
      });
    }
  });
})();
